import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar"; // Updated Navbar component
import { useCombinedContext } from "../../context/CombinedContext";
import "./Dashboard.css";
import Loader from "../Loading/Loader";
import axiosInstance from "../../services/auth";
import { toast } from "react-toastify";

const Dashboard = () => {
  const { setCompany, loading, setLoading } = useCombinedContext();
  const navigate = useNavigate();

  useEffect(() => {
    const loadAuthData = async () => {
      try {
        // Fetch authData using axios
        const response = await axiosInstance.get("company/userCompany");
        // Update state with the fetched data
        // console.log("company data in nav",response.data.companies)
        const company = response.data.companies;
        setCompany(company);
      } catch (error) {
        // console.error('Error fetching company data:', error);
        toast.error("Error fetching company data");
      }
    };

    loadAuthData();
  }, [setCompany]); // Empty dependency array ensures this runs only once

  // Show loader if the app is still loading
  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div className="content-dashboard ">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
